// import axios from 'axios'
import {axios, api, API_URL} from '../services/api';

// Authentification
export function login(email: string, password: string): any {
  return axios.post<{ email: string, password: string }>(`${API_URL}/api/login`, {
    email,
    password,
  })
}

export function getUserCredentials(email: string): any {
  return api.post<{ email: string }>(`${API_URL}/api/user/credential`, {email})
}

// Statistique

export function getStatistic(userId: Number | null = null, annee: string = ''): any {
  let params = userId ? `userId=${userId}` : '';

  if (annee !== '') params += `${userId ? '&' : ''}annee=${annee}`;

  return api.get(`${API_URL}/api/dashboard?${params}`)
}

// Statistique indicateur

export function getDashoardFilter(userId: string = ''): any {
  let params = userId ? `?userId=${userId}` : '';
  return api.get(`${API_URL}/api/dashboard/indicateur/filtres${params}`)
}

export function getStatisticIndicateur(
  userId: string = '',
  source: string = '',
  annee: string = '',
  mois: string = '',
  statut: string = '',
  partenaire: string = '',
): any {
  let params = '';

  if (userId) params += `userId=${userId}`;
  if (source) params += `${userId ? '&' : ''}source=${source}`;
  if (annee) params += `${source ? '&' : ''}annee=${annee}`;
  if (mois) params += `&mois=${mois}`;
  if (statut) params += `&statut=${statut}`;
  if (partenaire) params += `&partenaire=${partenaire}`;

  return api.get(`${API_URL}/api/dashboard/indicateur?${params}`)
}

// Dossier

export function getDossiersPrincipal(
  page: number = 1,
  userId: string = '',
  reference: string = '',
  statut: string = '',
  partenaire: string = '',
  marque: string = '',
  modele: string = '',
  immatriculation: string = '',
  source: string = '',
  dateAfter: string = '',
  dateBefore: string = '',
  referencePartenaire: string = '',
  nomProprietaire: string = '',
): any {
  let params = `page=${page}`

  if (userId) params += `&userId=${userId}`
  if (reference) params += `&reference=${reference}`
  if (statut) params += `&libelleStatut=${statut}`
  if (partenaire) params += `&nomPartenaire=${partenaire}`
  if (marque) params += `&marque=${marque}`
  if (modele) params += `&modele=${modele}`
  if (immatriculation) params += `&immatriculation=${immatriculation}`
  if (source) params += `&libelleSource=${source}`
  if (dateAfter) params += `&dateDebut=${dateAfter}`
  if (dateBefore) params += `&dateFin=${dateBefore}`
  if (referencePartenaire) params += `&referencePartenaire=${referencePartenaire}`
  if (nomProprietaire) params += `&nomProprietaire=${nomProprietaire}`

  return api.get(`${API_URL}/api/list/dossiers?${params}`)
}

export function getDossiersSecondaire(
  page: number = 1,
  userId: string = '',
  reference: string = '',
  source: string = '',
  marque: string = '',
  modele: string = '',
  immatriculation: string = '',
): any {
  let params = `page=${page}`

  if (userId) params += `&userId=${userId}`
  if (reference) params += `&reference=${reference}`
  if (source) params += `&libelleSource=${source}`
  if (marque) params += `&marque=${marque}`
  if (modele) params += `&modele=${modele}`
  if (immatriculation) params += `&immatriculation=${immatriculation}`

  return api.get(`${API_URL}/api/search/dossiers?${params}`)
}

export function getDossierById(id: string): any {
  return api.get(`${API_URL}/api/dossiers/${id}`)
}

// Sinistre

export function createSinistre(data: any): any {
  return api.post(`${API_URL}/api/sinistres`, data)
}

export function updateSinistre(id: number, data: any): any {
  return api.patch(`${API_URL}/api/sinistres/${id}`, data)
}

// Propriétaire

export function createProprietaire(data: any): any {
  return api.post(`${API_URL}/api/proprietaires`, data)
}

export function updateProprietaire(id: number, data: any): any {
  return api.patch(`${API_URL}/api/proprietaires/${id}`, data)
}

// Dépositaire

export function createDepositaire(data: any): any {
  return api.post(`${API_URL}/api/depositaires`, data)
}

export function updateDepositaire(id: number, data: any): any {
  return api.patch(`${API_URL}/api/depositaires/${id}`, data)
}

// Enlèvement

export function createEnlevement(data: any): any {
  return api.post(`${API_URL}/api/enlevements`, data)
}

export function updateEnlevement(id: number, data: any): any {
  return api.patch(`${API_URL}/api/enlevements/${id}`, data)
}

// Frais

export function createFrais(data: any): any {
  return api.post(`${API_URL}/api/frais`, data)
}

export function updateFrais(id: number, data: any): any {
  return api.patch(`${API_URL}/api/frais/${id}`, data)
}

// Source

export function getSource(): any {
  return api.get(`${API_URL}/api/sources`)
}

// Partenaire

export function getPartenaires(): any {
  return api.get(`${API_URL}/api/partenaires`)
}

// Partenaire et Status

export function getDossiersFilter(): any {
  return api.get(`${API_URL}/api/partenairesAndStatuts`)
}

// Véhicule

export function editVehicle(vehicle: any): any {
  return api.patch<any>(
    `${API_URL}/api/vehicule/edit`,
    vehicle
  )
}

// Utilisateur

export function getUtilisateurs(
  page: number = 1,
  search: string = '',
  utilisateurRole: string = ''
): any {
  let params = `?page=${page}`;

  if (search !== '') params += `&search=${search}`;
  if (utilisateurRole !== '') params += `&utilisateurRole=${utilisateurRole}`;

  return api.get(`${API_URL}/api/list/utilisateurs${params}`);
}

export function getUtilisateurById(id: string): any {
  return api.get(`${API_URL}/api/utilisateurs/${id}`)
}

export function createUtilisateur(data: any): any {
  return api.post(`${API_URL}/api/utilisateurs`, data)
}

export function updateUtilisateur(id: number, data: any): any {
  return api.put(`${API_URL}/api/utilisateurs/${id}`, data)
}

export function deleteUtilisateur(id: number): any {
  return api.delete(`${API_URL}/api/utilisateurs/${id}`)
}

export function confirmUserPassword(data: any): any {
  return axios.post(`${API_URL}/api/confirm/utilisateurs`, data)
}

export function reSendConfirmUserPassword(id: number): any {
  return api.post(`${API_URL}/api/resend/confirm/utilisateurs/${id}`)
}

// Utilisateur Rôle

export function getUtilisateurRoles(): any {
  return api.get(`${API_URL}/api/utilisateur_roles`)
}

// Document

export function addDocument(idDossier: number, formData: any): any {
  return api.post(`${API_URL}/api/documents/upload/${idDossier}`, formData, {
    headers: {'Content-type': 'multipart/form-data'},
  })
}

// Etat & Choc

export function getEtatChocs(
  page: number = 1,
  type: string = '',
  search: string = '',
): any {
  let params = `?page=${page}`;

  if (type !== '') params += `&type=${type}`;
  if (search !== '') params += `&search=${search}`;

  return api.get(`${API_URL}/api/list/etat_chocs${params}`);
}

export function getAllEtatChocs(): any {
  return api.get(`${API_URL}/api/list/all/etat_chocs`);
}

export function getEtatChocById(id: string): any {
  return api.get(`${API_URL}/api/etat_chocs/${id}`);
}

export function createEtatChoc(data: any): any {
  return api.post(`${API_URL}/api/etat_chocs`, data);
}

export function updateEtatChoc(id: number, data: any): any {
  return api.put(`${API_URL}/api/etat_chocs/${id}`, data);
}

export function deleteEtatChoc(id: number): any {
  return api.delete(`${API_URL}/api/etat_chocs/${id}`);
}

// 2FA

export function getTwoFactorSetup(): any {
  return api.get(`${API_URL}/api/2fa/setup`);
}

export function verifyTwoFactorCode(code: string, method?: string): any {
  return api.post(`${API_URL}/api/2fa/verify`, {code, method});
}

export function verifyBackupCode(code: string): any {
  return api.post(`${API_URL}/api/2fa/backup-verify`, {code});
}

export function resetUserTwoFactor(userId: number): any {
  return api.post(`${API_URL}/api/2fa/reset`, {userId});
}

export function changeTwoFactorMethod(userId: number, twoFactorMethod: string): any {
  return axios.put(`${API_URL}/api/2fa/method/${userId}`, {twoFactorMethod});
}

// Rôle rubrique

// API Roles
export const roleApi = {
  getAll: (search: string = '') => api.get(`${API_URL}/api/roles${search !== '' ? `?search=${search}` : ''}`),
  create: (data: any) => api.post(`${API_URL}/api/roles`, data),
  update: (id: number, data: any) => api.put(`${API_URL}/api/roles/${id}`, data),
  delete: (id: number) => api.delete(`${API_URL}/api/roles/${id}`),
}

// API Rubriques
export const rubriqueApi = {
  getAll: () => api.get(`${API_URL}/api/rubriques`),
}

// API Rubriques
export const rubriqueCategorieApi = {
  getAll: () => api.get(`${API_URL}/api/rubrique_categories`),
}